import { getTopLevelDomain } from '~/config'

export const getCountryCodeByCurrentDomain = (): string => getTopLevelDomain().toUpperCase()
